import script from "./PatTestingComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./PatTestingComponent.vue?vue&type=script&setup=true&lang=js"

import "./PatTestingComponent.vue?vue&type=style&index=0&id=2112a510&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2112a510"]])

export default __exports__